import { SectionLayout } from '../../shared-components/SectionLayout'
import { SubscriptionsBreadcrumb } from '../SubscriptionBreadcrumbs'
import { OrganisationDetailsBanner } from './OrganisationDetailsBanner'
import { OrgPlatformAdminsSection } from './OrgPlatformAdminsSection'

export const OrganisationDetailsPage = () => {
  return (
    <>
      <SubscriptionsBreadcrumb title="Details" />
      <SectionLayout>
        <OrganisationDetailsBanner />
        <OrgPlatformAdminsSection />
      </SectionLayout>
    </>
  )
}
